export default "__VITE_PUBLIC_ASSET__c0a24a20__"